export default __webpack_public_path__ + "static/media/portfolio-cai-4.da0f15ac.jpg";